"use client";
import { jsxs as a, Fragment as c, jsx as t } from "react/jsx-runtime";
import { visuallyHidden as p } from "../../styles/mixins/visuallyHidden.js";
import f from "../../../components/visually-hidden/VisuallyHidden.js";
import { css as u } from "@emotion/react";
import i from "@emotion/styled";
import { COLORS as l } from "../../../tokens/colors/Colors.js";
import { FONT_SIZES as b } from "../../../tokens/font-sizes/FontSizes.js";
import { forwardRef as y, Fragment as $ } from "react";
const L = y(
  ({
    children: r,
    feHideLabel: e = !1,
    feRequired: o = !1,
    feRequiredText: s = "Required",
    feSize: m = "md",
    ...d
  }, n) => /* @__PURE__ */ a(g, { ...d, "data-comp": "label", feHideLabel: e, feSize: m, ref: n, children: [
    r,
    o && /* @__PURE__ */ a(c, { children: [
      /* @__PURE__ */ t(e ? $ : f, { children: ` (${s})` }),
      /* @__PURE__ */ t(h, { "aria-hidden": !0, children: " *" })
    ] })
  ] })
);
L.displayName = "Label";
const g = i.label(
  ({
    feDisabled: r,
    feHideLabel: e,
    feSize: o
  }) => u`
		color: ${r ? l.gray600 : l.black};
		cursor: ${r ? "not-allowed" : "pointer"};
		display: block;
		font-size: ${o === "sm" && b.sm};
		margin: 0;

		${e && p}
	`
), h = i.span`
	color: ${l.redBase};
`;
export {
  L as default
};
